import Vue from "vue";
import VueRouter from "vue-router";
import {
  PATH_LOGIN,
  PATH_REGISTER,
  PATH_PROFILE,
  PATH_PAGE_NOT_FOUND,
  // PATH_WINDOWS,
  PATH_RFQWINDOWS,
  // PATH_RFQ,
  PATH_WINDOW_PROJECTS,
  PATH_WINDOWSCONFIG,
  PATH_PROJECT_DETAIL,
  PATH_HOME,
  PATH_MOB_PROJECTS,
  PATH_MOB_PROJECT_DETAIL,
  PATH_MOB_QRCODE,
  PATH_SUBMIT_BID,
  PATH_PROJECT_LIST,
  PATH_PROJECT_LIST_DETAILS,
  PATH_PROJECT_CHOOSER,
  // PATH_VIEWER,
  PATH_DEALER,
  PATH_PROJECT
} from "@/data/pathData";

import { authMiddleware, guestMiddleware } from "@/middlewares";

Vue.use(VueRouter);

const routes = [
  {
    path: PATH_LOGIN,
    name: "Login",
    component: () => import("@/views/auth/Login"),
    meta: {
      layout: "auth-layout",
      middleware: [guestMiddleware]
    }
  },

  {
    path: PATH_REGISTER,
    name: "Register",
    component: () => import("@/views/auth/Register"),
    meta: {
      layout: "auth-layout",
      middleware: [guestMiddleware]
    }
  },

  {
    path: PATH_HOME,
    name: "Home",
    component: () => import("@/views/Home"),
    meta: {
      layout: "dashboard-layout",
      middleware: [authMiddleware]
    }
  },

  {
    path: PATH_DEALER,
    name: "Dealer",
    component: () => import("@/views/Dealer"),
    meta: {
      layout: "dashboard-layout",
      middleware: [authMiddleware]
    }
  },
  {
    path: PATH_PROJECT,
    name: "Project",
    component: () => import("@/views/Project"),
    meta: {
      layout: "dashboard-layout",
      middleware: [authMiddleware]
    }
  },

  {
    path: "/dealer/rfq",
    name: "DealerRFQ",
    component: () => import("@/views/DealerRFQ"),
    meta: {
      layout: "dashboard-layout",
      middleware: [authMiddleware]
    }
  },

  {
    path: "/project/:id/schedule/:name",
    name: "Windows",
    component: () => import("@/views/ProjectDetails"),
    meta: {
      layout: "dashboard-layout",
      middleware: [authMiddleware]
    }
  },

  // Dealer Project Details from RFQ
  {
    path: "/dealer/rfq/:id",
    name: "dealer-project-details",
    component: () => import("@/views/DealerProjectDetails"),
    meta: {
      layout: "dashboard-layout",
      middleware: [authMiddleware]
    }
  },
  {
    path: "/dealer/quotes/:id",
    name: "dealer-quotes",
    component: () => import("@/views/DealerQuotes"),
    meta: {
      layout: "dashboard-layout",
      middleware: [authMiddleware]
    }
  },
  {
    path: PATH_RFQWINDOWS,
    name: "rfqWindows",
    component: () => import("@/views/rfqWindows"),
    meta: {
      layout: "dashboard-layout"
      // middleware: [authMiddleware],
    }
  },
  {
    path: "/rfq/project/:id/schedule/:name",
    name: "rfq",
    component: () => import("@/views/ContractorRFQ"),
    meta: {
      layout: "dashboard-layout"
      // middleware: [authMiddleware],
    }
  },
  {
    path: PATH_WINDOWSCONFIG,
    name: "windowsconfiguration",
    component: () => import("@/views/windowConfiguration"),
    meta: {
      layout: "dashboard-layout"
      // middleware: [authMiddleware],
    }
  },

  {
    path: PATH_PROJECT_DETAIL,
    name: "projectDetails",
    component: () => import("@/views/dealer/ProjectDetail"),
    meta: {
      layout: "dashboard-layout"
      // middleware: [authMiddleware],
    }
  },
  {
    path: PATH_WINDOW_PROJECTS,
    name: "projects",
    component: () => import("@/views/dealer/Projects"),
    meta: {
      layout: "dashboard-layout"
      // middleware: [authMiddleware],
    }
  },

  {
    path: PATH_SUBMIT_BID,
    name: "submit_bid",
    component: () => import("@/views/dealer/Bid"),
    meta: {
      layout: "dashboard-layout"
      // middleware: [authMiddleware],
    }
  },

  {
    path: PATH_MOB_PROJECTS,
    name: "mobile_projects",
    component: () => import("@/views/mobile/Projects"),
    meta: {
      layout: "mobile-layout"
      // middleware: [authMiddleware],
    }
  },

  {
    path: PATH_MOB_PROJECT_DETAIL,
    name: "mobile_projects_detail",
    component: () => import("@/views/mobile/ProjectDetail"),
    meta: {
      layout: "mobile-layout"
      // middleware: [authMiddleware],
    }
  },

  {
    path: PATH_MOB_QRCODE,
    name: "mobileqrcode",
    component: () => import("@/views/mobile/QRCode"),
    meta: {
      layout: "mobile-layout"
      // middleware: [authMiddleware],
    }
  },

  {
    path: PATH_PROFILE,
    name: "Profile",
    component: () => import("@/views/Profile"),
    meta: {
      layout: "dashboard-layout",
      middleware: [authMiddleware]
    }
  },

  {
    path: PATH_PAGE_NOT_FOUND,
    component: () => import("@/views/PageNotFound.vue"),
    meta: {
      layout: "auth-layout"
    }
  },
  {
    path: PATH_PROJECT_LIST,
    name: "projectList",
    component: () => import("@/views/projectList/projectList"),
    meta: {
      layout: "project-layout"
      // middleware: [authMiddleware],
    }
  },
  {
    path: PATH_PROJECT_LIST_DETAILS,
    name: "projectListDetails",
    component: () => import("@/views/projectList/projectListDetails"),
    meta: {
      layout: "project-layout"
      // middleware: [authMiddleware],
    }
  },
  {
    path: PATH_PROJECT_CHOOSER,
    name: "projectChooser",
    component: () => import("@/views/chooserView/chooserPage"),
    meta: {
      layout: "project-layout"
      // middleware: [authMiddleware],
    }
  },

  // Admin Routes
  {
    path: "/admin-users",
    name: "Users",
    component: () => import("@/views/Users"),
    meta: {
      layout: "dashboard-layout",
      middleware: [authMiddleware]
    }
  },

  {
    path: "/dealers",
    name: "Dealers",
    component: () => import("@/views/Dealers"),
    meta: {
      layout: "dashboard-layout",
      middleware: [authMiddleware]
    }
  },

  {
    path: "/contractors",
    name: "Contractors",
    component: () => import("@/views/Contractors"),
    meta: {
      layout: "dashboard-layout",
      middleware: [authMiddleware]
    }
  },

  {
    path: "/architects",
    name: "Architects",
    component: () => import("@/views/Architects"),
    meta: {
      layout: "dashboard-layout",
      middleware: [authMiddleware]
    }
  }
];

const router = new VueRouter({
  routes,
  mode: "history"
});

// Middleware utility
function nextFactory(context, middleware, index) {
  const subsequentMiddleware = middleware[index];
  // If no subsequent Middleware exists,
  // the default `next()` callback is returned.
  if (!subsequentMiddleware) return context.next;

  return (...parameters) => {
    // Run the default Vue Router `next()` callback first.
    context.next(...parameters);
    // Then run the subsequent Middleware with a new
    // `nextMiddleware()` callback.
    const nextMiddleware = nextFactory(context, middleware, index);
    subsequentMiddleware({ ...context, next: nextMiddleware });
  };
}

router.beforeEach((to, from, next) => {
  // Always top positon window
  window.scrollTo(0, 0);

  if (to.meta.middleware) {
    const middleware = Array.isArray(to.meta.middleware)
      ? to.meta.middleware
      : [to.meta.middleware];

    const context = {
      from,
      next,
      router,
      to
    };
    const nextMiddleware = nextFactory(context, middleware, 1);

    return middleware[0]({ ...context, next: nextMiddleware });
  }

  return next();
});

export default router;
